import { mapGetters, mapMutations } from "vuex";
import PayHeader from "../../components/PayHeader/index.vue";
import PayFooter from "../../components/PayFooter/index.vue";
import AccordionLoading from "../../components/AccordionLoading/index.vue";
import CircleLoading from "../../components/CircleLoading/index.vue";
import { payAxios } from "../../axios";

// import image1 from '../../assets/image/coin_1.png'
// import image2 from '../../assets/image/coin_2.png'
// import image3 from '../../assets/image/coin_3.png'
// import image4 from '../../assets/image/coin_4.png'
// import image5 from '../../assets/image/coin_5.png'
// import image6 from '../../assets/image/coin_6.png'
import { reactive } from 'vue';

// let imageObj = reactive({
//   key1: image1,
//   key2: image2,
//   key3: image3,
//   key4: image4,
//   key5: image5,
//   key6: image6,
// })

export default {
  name: "Home",
  components: { PayHeader, PayFooter, CircleLoading, AccordionLoading },
  data() {
    return {
      channels: null,
      role: 1,
      // items:[]
    };
  },
  computed: {
    ...mapGetters(["profile", "assetsPrefix", "getDeviceToken"]),
    avatar() {
      return this.profile && this.profile.avatar
        ? `${this.assetsPrefix}/${this.profile.avatar}?x-oss-process=image/resize,m_fill,h_300,w_300`
        : "";
    },
  },
  methods: {
    ...mapMutations(["setRecords"]),
    /**
     * 从远程获取channel列表
     * @returns channels
     */
    async fetchChannels() {
      // console.log(77);
      try {
        const {
          data: { channels = [], role = 1 },
        } = await payAxios.post(`/pplat.PPlatService/ListChannels`);
        this.role = role;
        return channels;
      } catch (error) {
        return [];
      }
    },
    /**
     * 从远程获取指定channel的商品列表
     * @param {Object} paramObj 参数
     * @returns goods
     */
    async fetchGoods({ channelId: channel_id, methodId: method_id }) {
      try {
        const {
          data: { goods = [] },
        } = await payAxios.post(`/pplat.PPlatService/ListGoods`, {
          channel_id,
          method_id, 
          filter: {
            catagory: 0,
            category: 0,
          }

        });
        return goods;
      } catch (error) {
        console.log("error", error);
        return [];
      }
    },
    /**
     * 下单
     * @param {Object} param0 下单参数
     */
    async order({
      channelId: channel_id,
      methodId: method_id,
      goodsId: goods_id,
      ticket,
    }) {
      if (this.pending) return;
      try {
        this.pending = true;
        const {
          data: { prepUrl },
        } = await payAxios.post(
          `/pplat.PPlatService/Order`,
          {
            request_id: `${Date.now()}${(Math.random() * 9000 + 1000) << 0}`,
            channel_id,
            method_id,
            goods_id,
            ticket,
          },
          {
            headers: {
              "Grpc-Metadata-dtoken": this.getDeviceToken,
            },
          }
        );
        if (prepUrl) {
          window.location.href = prepUrl;
        }
      } catch (error) {
        // ignore
      } finally {
        this.pending = false;
      }
    },
    jumpRecharge() {
      location.href = `${location.origin}/thridAgentRecharge/index.html`;
    },
    /**
     * 展开和收起渠道商品列表
     * @param {Number} index channels索引
     */
    async expand(index) {
      const channel = this.channels[index];
      channel.expanded = !channel.expanded;
      if (!channel.items && !channel.loading) {
        channel.loading = true;
        let goods = [];
        try {
          goods = await this.fetchGoods(this.channels[index]);
        } catch (error) {
          // ignore
        } finally {
          // this.$set(channel, 'items', goods)
          channel.items = goods;
          channel.loading = false;
        }
      }
    },
    submit(channel, good) {
      this.order({ ...channel, ...good });
    },
    // getImageURL(i) {
    //   let key = 'key' + (i + 1)
    //   return imageObj[key]
      
    // }
  },
  async mounted() {
    if (!this.channels) {
      this.channels = (await this.fetchChannels()).map((channel) => ({
        loading: false,
        expanded: false,
        ...channel,
      }));
      // 默认不打开第一个渠道
      // this.channels.length && this.expand(0)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (from.name === "login") {
        vm.channels = null;
        vm.channels = (await vm.fetchChannels()).map((channel) => ({
          loading: false,
          expanded: false,
          ...channel,
        }));
        console.log(vm.channels, 'vm.channels...')
        // 默认不打开第一个渠道
        // vm.channels.length && vm.expand(0)
      }
    });
  },
  inject: ["$t"],
};
